export const xenditCardNumberMaskId = 'xendit-card-number-mask'

export const xenditCardExpirationMonthId = 'xendit-card-expiration-month'

export const xenditCardHolderNameId = 'xendit-card-holder-name'

export const xenditCardSecurityCodeId = 'xendit-card-security_code'
